import { useMemo } from 'react';
import { TableDefinition } from '~/Components/DataTable/DataTable.types';
import { IFitoList } from '~/Components/FitoList/FitoListUncontrolled/interfaces';
import { IAttendance } from '~/Models/DTO/Attendance.model';
import { useAttendanceColumns } from './useAttendanceColumns';

export const useAttendance = () => {
  const { columnMap } = useAttendanceColumns();

  const keyOfId: keyof IAttendance = 'checkInTime';

  const createListItem = (item: IAttendance) => ({
    header: item.customerName,
    subheader: `${item.eventName}, ${item.locationName}`,
    active: item.active,
    dateTimeStatus: {
      date: item.checkInTime,
      status: item.bookingState,
    },
  });
  const setItemValues = (item: IAttendance): IFitoList => createListItem(item);

  const settings = {
    tabs: false,
    search: true,
    pagination: false,
    multiSelect: false,
  };

  const tableDefinition: TableDefinition = useMemo(
    () => ({
      columns: [
        columnMap.name,
        columnMap.eventName,
        columnMap.eventType,
        columnMap.location,
        columnMap.date,
        columnMap.time,
      ],
      config: { useSelectableRows: false, usePagination: false },
    }),
    [columnMap],
  );

  return {
    keyOfId,
    setItemValues,
    settings,
    tableDefinition,
  };
};
